/**
 * Token generation utilities for view authentication and project sharing
 * View tokens: 6-digit numeric strings, globally unique (DATA-003)
 * Share tokens: UUID v4 strings for public share URLs
 */

const TOKEN_LENGTH = 6;

/**
 * Generate a random 6-digit numeric token
 * Format: 123456 (6 digits)
 */
export function generateToken(): string {
  let token = '';
  for (let i = 0; i < TOKEN_LENGTH; i++) {
    const randomDigit = Math.floor(Math.random() * 10);
    token += randomDigit.toString();
  }
  return token;
}

/**
 * Validate token format (6 numeric digits)
 */
export function isValidTokenFormat(token: string): boolean {
  if (!token || token.length !== TOKEN_LENGTH) {
    return false;
  }

  // Check all characters are digits
  return /^\d{6}$/.test(token);
}

/**
 * Format token for display with # prefix
 * Example: 123456 → #123456
 */
export function formatTokenDisplay(token: string): string {
  return `#${token}`;
}

/**
 * Generate a share token (UUID v4) for project sharing URLs
 * Used in public URLs: app.masterlapse.com/s/{shareToken}
 */
export function generateShareToken(): string {
  return crypto.randomUUID();
}
